/**
 * note icons with number prefixes have different variations in the design system
 * @see https://www.figma.com/file/TWgty8gcTip6JWbfKJigFb/WL-Styles-v1.0-Breve?type=design&node-id=3805-10187&mode=design&t=CCP5nfSLNAUphCNf-0
 * @note _1 is a stroke of width 1
 */
export enum IconType {
  'accessTime' = 'accessTime',
  'accessTimeV2' = 'accessTimeV2',
  'accessTimeFilled' = 'accessTimeFilled',
  'add' = 'add',
  'admin' = 'admin',
  'adminFilled' = 'adminFilled',
  'alignLeft01' = 'alignLeft01',
  'alignRight01' = 'alignRight01',
  'announcement' = 'announcement',
  'announcement01_simple' = 'announcement01_simple',
  'announcement01' = 'announcement01',
  'arrowCircle' = 'arrowCircle',
  'arrowLeft' = 'arrowLeft',
  'arrowNarrowRight' = 'arrowNarrowRight',
  'arrowRight' = 'arrowRight',
  'arrowNarrowUp' = 'arrowNarrowUp',
  'arrowUpRight' = 'arrowUpRight',
  'arrowUpRight-01' = 'arrowUpRight-01',
  'bank' = 'bank',
  'bankNote' = 'bankNote',
  'bankNote_1' = 'bankNote_1',
  'bell' = 'bell',
  'bookClosed' = 'bookClosed',
  'bookmark' = 'bookmark',
  'bookmarkFilled' = 'bookmarkFilled',
  'bookOpen01' = 'bookOpen01',
  'bookOpen02' = 'bookOpen02',
  'building07' = 'building07',
  'calendar' = 'calendar',
  'carusoLogomark' = 'carusoLogomark',
  'check' = 'check',
  'checkCircle' = 'checkCircle',
  'checkbox' = 'checkbox',
  'checkbox2' = 'checkbox2',
  'checkboxChecked' = 'checkboxChecked',
  'checkboxCheckedFilled' = 'checkboxCheckedFilled',
  'checkboxIndeterminate' = 'checkboxIndeterminate',
  'chevronDown' = 'chevronDown',
  'chevronLeft' = 'chevronLeft',
  'chevronRight' = 'chevronRight',
  'chevronSelectorVertical' = 'chevronSelectorVertical',
  'chevronUp' = 'chevronUp',
  'circle' = 'circle',
  'clear' = 'clear',
  'clipboardCheck' = 'clipboardCheck',
  'clock' = 'clock',
  'clockRewind' = 'clockRewind',
  'close' = 'close',
  'codepen' = 'codepen',
  'codeSquare' = 'codeSquare',
  'codeSquare_1' = 'codeSquare_1',
  'combineClips' = 'combineClips',
  'combineClipsFilled' = 'combineClipsFilled',
  'copy' = 'copy',
  'copyFilled' = 'copyFilled',
  'creditCard' = 'creditCard',
  'creditCard01' = 'creditCard01',
  'cursor-box' = 'cursor-box',
  'cues' = 'cues',
  'customerCare' = 'customerCare',
  'delete' = 'delete',
  'deleteFilled' = 'deleteFilled',
  'dotsGrid' = 'dotsGrid',
  'dotsSix' = 'dotsSix',
  'download' = 'download',
  'download02' = 'download02',
  'dragHandle' = 'dragHandle',
  'edit' = 'edit',
  'editFilled' = 'editFilled',
  'edit-03' = 'edit-03',
  'ex' = 'ex',
  'exclamation' = 'exclamation',
  'exclamation02' = 'exclamation02',
  'expand' = 'expand',
  'export' = 'export',
  'eye' = 'eye',
  'eyeOff' = 'eyeOff',
  'faceContent' = 'faceContent',
  'faceSad' = 'faceSad',
  'faceSmile' = 'faceSmile',
  'favorite' = 'favorite',
  'favoriteBordered' = 'favoriteBordered',
  'favoriteFilled' = 'favoriteFilled',
  'file02' = 'file02',
  'file06_1' = 'file06_1',
  'fileCheck' = 'fileCheck',
  'fileProject' = 'fileProject',
  'filterFunnel' = 'filterFunnel',
  'folder' = 'folder',
  'folderFilled' = 'folderFilled',
  'gamingPad01' = 'gamingPad01',
  'globe02' = 'globe02',
  'globe05' = 'globe05',
  'graduationHat01' = 'graduationHat01',
  'graduationHat02' = 'graduationHat02',
  'grid01' = 'grid01',
  'heart' = 'heart',
  'heartCircle' = 'heartCircle',
  'heartHand' = 'heartHand',
  'heartProfile' = 'heartProfile',
  'import' = 'import',
  'infoCircle' = 'infoCircle',
  'integrations' = 'integrations',
  'key' = 'key',
  'lightbulb' = 'lightbulb',
  'lightbulb02' = 'lightbulb02',
  'lightning01' = 'lightning01',
  'link' = 'link',
  'link02' = 'link02',
  'link03' = 'link03',
  'linkBroken02' = 'linkBroken02',
  'linkExternal01' = 'linkExternal01',
  'lock' = 'lock',
  'lock03' = 'lock03',
  'lockFilled' = 'lockFilled',
  'lockUnlocked' = 'lockUnlocked',
  'lockUnlockedFilled' = 'lockUnlockedFilled',
  'logoMark' = 'logoMark',
  'loop' = 'loop',
  'magicWand01' = 'magicWand01',
  'mail-02' = 'mail-02',
  'markerPin' = 'markerPin',
  'medicalCross' = 'medicalCross',
  'menu' = 'menu',
  // note this is semi-deprecated and not following alphabetical order since they are practically the same
  'helpCircle' = 'helpCircle',
  'messageQuestionCircle' = 'messageQuestionCircle',
  'messageSmileCircle' = 'messageSmileCircle',
  'messageTextSquare02' = 'messageTextSquare02',
  'messageSquare02' = 'messageSquare02',
  'microphone01' = 'microphone01',
  'microphone01_1' = 'microphone01_1',
  'microphone02' = 'microphone02',
  'minus-circle' = 'minus-circle',
  'minus' = 'minus',
  'monitor' = 'monitor',
  'monitor02' = 'monitor02',
  'moreHoriz' = 'moreHoriz',
  'moreVert' = 'moreVert',
  'move' = 'move',
  'openInNew' = 'openInNew',
  'package' = 'package',
  'palette' = 'palette',
  'paperclip' = 'paperclip',
  'passcode' = 'passcode',
  'pause' = 'pause',
  'pauseFilled' = 'pauseFilled',
  'pencil01' = 'pencil01',
  'pencil02' = 'pencil02',
  'person' = 'person',
  'person_1' = 'person_1',
  'personFilled' = 'personFilled',
  'phone' = 'phone',
  'phone02' = 'phone02',
  'phonetic' = 'phonetic',
  'phonetic02' = 'phonetic02',
  'phoneticFilled' = 'phoneticFilled',
  'play' = 'play',
  'playArrow' = 'playArrow',
  'playArrow_1' = 'playArrow_1',
  'playArrowFilled' = 'playArrowFilled',
  'plus' = 'plus',
  'presentationalChart01' = 'presentationalChart01',
  'presentationChart03' = 'presentationChart03',
  'public' = 'public',
  'publicFilled' = 'publicFilled',
  'puzzlePiece02' = 'puzzlePiece02',
  'questionMarkCircle' = 'questionMarkCircle',
  'recording02' = 'recording02',
  'refresh-ccw-01' = 'refresh-ccw-01',
  'refresh-cw-03' = 'refresh-cw-03',
  'refresh' = 'refresh',
  'replay' = 'replay',
  'reverse-left' = 'reverse-left',
  'reverse-right' = 'reverse-right',
  'rows01' = 'rows01',
  'rows03' = 'rows03',
  'script-select' = 'script-select',
  'script' = 'script',
  'search' = 'search',
  'send' = 'send',
  'sendFilled' = 'sendFilled',
  'settings' = 'settings',
  'settings01' = 'settings01',
  'settings02' = 'settings02',
  'settingsFilled' = 'settingsFilled',
  'share' = 'share',
  'share07' = 'share07',
  'shareFilled' = 'shareFilled',
  'signal02' = 'signal02',
  'sliders04' = 'sliders04',
  'social-icon-google' = 'social-icon-google',
  'social-icon-linkedin' = 'social-icon-linkedin',
  'social-icon-microsoft' = 'social-icon-microsoft',
  'square' = 'square',
  'stand' = 'stand',
  'stars01' = 'stars01',
  'stars02' = 'stars02',
  'stars03' = 'stars03',
  'studio' = 'studio',
  'switch01' = 'switch01',
  'target' = 'target',
  'team' = 'team',
  'team_1' = 'team_1',
  'teamFilled' = 'teamFilled',
  'thumbsDown' = 'thumbsDown',
  'thumbsUp' = 'thumbsUp',
  'tool02' = 'tool02',
  'toolbar' = 'toolbar',
  'trash' = 'trash',
  'trash02' = 'trash02',
  'trash04' = 'trash04',
  'truck01' = 'truck01',
  'tv03' = 'tv03',
  'type' = 'type',
  'typeStrikethrough' = 'typeStrikethrough',
  'unitedStatesFlag' = 'unitedStatesFlag',
  'unitedKingdomFlag' = 'unitedKingdomFlag',
  'upload' = 'upload',
  'upload01' = 'upload01',
  'user02' = 'user02',
  'userCircle' = 'userCircle',
  'userPlus' = 'userPlus',
  'userSquare' = 'userSquare',
  'usersSquare' = 'usersSquare',
  'users01' = 'users01',
  'users03' = 'users03',
  'usersPlus' = 'usersPlus',
  'visibility' = 'visibility',
  'visibilityFilled' = 'visibilityFilled',
  'visibilityOff' = 'visibilityOff',
  'visibilityOffFilled' = 'visibilityOffFilled',
  'voices' = 'voices',
  'warning' = 'warning',
  'warningCircle' = 'warningCircle',
  'warningFilled' = 'warningFilled',
  'workflow' = 'workflow',
  'xCircle' = 'xCircle',
  'xSm' = 'xSm',
  'youtube' = 'youtube',
  'diamond' = 'diamond',
  'diamond-01' = 'diamond-01',
  'arrow-circle-broken-up-right' = 'arrow-circle-broken-up-right',
  'clapperBoard' = 'clapperBoard',
  'emphasis' = 'emphasis',
  'retake' = 'retake',
  'cueSliders' = 'cueSliders',
}

export type AvailableIconTypes = keyof typeof IconType;
